import { useAppSelector } from '@/hooks'

export default function useUserWhitelabel() {
  return useAppSelector(
    (state) => state.user.user?.profile?.utility_white_label ?? undefined,
  )
}
